<script>
    import { slide, fade } from "svelte/transition";
    export let title = "";
    export let expanded = true;

    function expand() {
        expanded = !expanded;
    }
</script>

<div class="root">
    <div on:click={expand} class="header">
        {#if expanded}
            <span class="material-icons" transition:fade={{ duration: 150 }}> expand_less </span>
        {:else}
            <span class="material-icons" transition:fade={{ duration: 150 }}> expand_more </span>
        {/if}
        <span class="title">{title}</span>
    </div>
    {#if expanded}
        <div transition:slide>
            <slot />
        </div>
    {/if}
</div>

<style>
    .root {
        display: flex;
        flex-direction: column;
        padding: 1rem;
        background: var(--back);
    }
    .header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0.5rem;
        border-bottom: solid var(--back_D15) 2px;
        box-sizing: border-box;
        position: relative;
    }
    .header .material-icons {
        font-size: 2.1rem;
        position: absolute;
    }
    .header .title {
        margin-left: 2.5rem;
        font-weight: 300;
        font-size: 1.3rem;
    }
</style>
